import { Stack } from '@mui/material'
import ContextConnectButton from '@/components/ContextCard/ContextConnectButton'

export default function AutomationSetupOpenButton({ onOpen }) {
  if (!onOpen) return null
  return (
    <Stack direction="row" justifyContent="flex-end">
      <ContextConnectButton hideIcon onClick={onOpen}>
        Open
      </ContextConnectButton>
    </Stack>
  )
}